import React from 'react';
import { FileText, Shield, Clock, CheckCircle } from 'lucide-react';
import CTASection from '../../components/CTASection';

const CopyrightRegistrationPage = () => {
  return (
    <div>
      <div className="bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-6">Copyright <span className="text-[#168356]">Registration</span></h1>
          <p className="text-xl text-gray-300 max-w-3xl">Protect your creative works with federal copyright registration. Secure exclusive rights to reproduce, distribute, and monetize your content.</p>
        </div>
      </div>
      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto space-y-6 text-lg text-gray-700">
            <p>Copyright protection exists automatically when you create an original work, but federal registration provides critical legal advantages. Registration is required to file infringement lawsuits and makes you eligible for statutory damages up to $150,000 per work plus attorney fees.</p>
            <p>We register all types of copyrightable works: literary works (books, articles, software code), visual arts (photographs, graphics, illustrations), musical works (songs, compositions), audiovisual works (videos, films), and architectural works.</p>
          </div>
        </div>
      </div>
      <div className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="bg-white rounded-xl p-6 text-center">
              <Shield className="w-12 h-12 text-[#168356] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Legal Protection</h3>
              <p className="text-gray-700 text-sm">Required to sue for infringement in federal court</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <FileText className="w-12 h-12 text-[#168356] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Public Record</h3>
              <p className="text-gray-700 text-sm">Establishes you as the legal owner of the work</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <CheckCircle className="w-12 h-12 text-[#168356] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Statutory Damages</h3>
              <p className="text-gray-700 text-sm">Eligible for up to $150,000 per work infringed</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <Clock className="w-12 h-12 text-[#168356] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Lifetime + 70 Years</h3>
              <p className="text-gray-700 text-sm">Protection lasts your lifetime plus 70 years</p>
            </div>
          </div>
        </div>
      </div>
      <CTASection />
    </div>
  );
};

export default CopyrightRegistrationPage;